import type { FaireProductEntity } from "../../entity_types/product";

export const p_gwpk2y3bjz: FaireProductEntity = {
  token: "p_gwpk2y3bjz",
  type: "product",
  name: "Roll Up 3-in-1 Game, Checkered Hearts",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/86388281c1a753773cb784d8c94c84038e280a8bee74f2598b109ff23b8d56e5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8015bd9693fe50e860db1361cb6cf96f627617bd6eaabd0afe69f74db722b40f.jpeg",
    "https://cdn.faire.com/fastly/3a12dabbfa216b0cfb15c9411a5bf182b93fa503463ee6f577fb9d643c32c78a.jpeg",
    "https://cdn.faire.com/fastly/cd4ff64286cc74672df26e92eaa1116e74410a3409ff969b0e7431860a993d42.jpeg",
    "https://cdn.faire.com/fastly/528967b5f9354e417818c82c20f0be25d664531591324821d79085dd751f7673.jpeg",
    "https://cdn.faire.com/fastly/172c9165aa330533adbd77ebe540acdad87ed64c2d12a65549a175279a5bae9f.jpeg",
    "https://cdn.faire.com/fastly/d0c85f570e9119851858c32b673f51bf0eb3ef424619105d8d2a2fbe17e1587b.jpeg",
    "https://cdn.faire.com/fastly/8debec5db01a61e7832a012f079a17f1a4334c5e56d42cef110ad2e88aeca423.jpeg",
    "https://cdn.faire.com/fastly/35e132d7c73318d4ebd4e943d2477ef7c89612ff17d7afc0016f834626d76f05.jpeg",
    "https://cdn.faire.com/fastly/f8332aabe38221ee77ed5370cdb63559013dfbec72915828ef198ae5000e7af8.jpeg",
    "https://cdn.faire.com/fastly/c99ee9ba49ac2d3960d950ac2782b2444e25e06843ee08167c0e47316e194890.jpeg",
    "https://cdn.faire.com/fastly/988d61ca175fc973a301cd453b1bd7ca69b0dbccee1afc400d9b98498601b9be.jpeg",
    "https://cdn.faire.com/fastly/827df39599310911d7b7ac407e1523ec76603e65d5694c1ef51cf84ed06c3c7f.jpeg",
    "https://cdn.faire.com/fastly/50c1f1af673c7202bcad6787504851273639f78faeb06bf216dd531d5f427d21.jpeg"
  ],
  priceDollars: 17,
  description: "Take your games on the go! This roll-up game set comes with everything you need to play checkers, chess, or backgammon—all in one compact, travel-friendly design. Whether you're plane-hopping, picnicking, or hanging at home, game night is always within reach.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• 3-in-1 game set: checkers, chess, and backgammon\n• Roll-up format for easy packing and portability\n• Comes with all necessary pieces\n• Perfect for travel, picnics, coffee tables, and game nights\n• Designed in Bando’s signature fun, colorful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and game retailers\n• Lifestyle, travel, and novelty boutiques\n• Families, travelers, students, and game lovers\n• Wholesale buyers seeking compact, giftable game sets",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:42.772Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
